import React from "react";
import { TextField, withStyles } from "@material-ui/core";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        width: '120px',
        marginTop: '10px',
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    cancel: {
        width: '120px',
        marginTop: '10px',
        marginRight: '10px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    formControl: {
        width: '100%'
    },
    datePicker: {
        width: '100%'
    }
});

const PlanFormConfiguration = (props) => {
    const { values, translations, errors, touched, handleChange, handleBlur, billingPlan } = props;

    return (
        <>
            {((billingPlan?.PostpaidAllowed && !billingPlan?.PrepaidAllowed) || (values.PostpaidAllowed && !values.PrepaidAllowed)) &&
                <>
                    <TextField
                        name="MinimalUsage"
                        value={values.MinimalUsage}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={!!(errors.MinimalUsage && touched.MinimalUsage)}
                        placeholder={translations["minimal_usage"] || 'Minimal usage'}
                        label={translations["minimal_usage"] || 'Minimal usage'}
                        margin={'dense'}
                        fullWidth={true}
                        type="number"
                        inputProps={{
                            min: 0,
                        }}
                    />
                    <TextField
                        name="IncludedUsage"
                        value={values.IncludedUsage}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={!!(errors.IncludedUsage && touched.IncludedUsage)}
                        placeholder={translations["included_monthly_usage"] || 'Included monthly usage'}
                        label={translations["included_monthly_usage"] || 'Included monthly usage'}
                        margin={'dense'}
                        fullWidth={true}
                        type="number"
                        inputProps={{
                            min: 0,
                        }}
                    />
                    <TextField
                        name="AllowedOveruse"
                        value={values.AllowedOveruse}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={!!(errors.AllowedOveruse && touched.AllowedOveruse)}
                        placeholder={translations["allowed_overuse_text"] || 'Allowed credit usage per month (leave empty if there is no limit)'}
                        label={translations["allowed_overuse_text"] || 'Allowed credit usage per month (leave empty if there is no limit)'}
                        margin={'dense'}
                        fullWidth={true}
                        type="number"
                        inputProps={{
                            min: 0,
                        }}
                    />

                    <TextField
                        name="MonthlyPrice"
                        value={values.MonthlyPrice}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={!!(errors.MonthlyPrice && touched.MonthlyPrice)}
                        placeholder={translations["monthly_price"] || 'Monthly price'}
                        label={translations["monthly_price"] || 'Monthly price'}
                        margin={'dense'}
                        fullWidth={true}
                        type="number"
                        inputProps={{
                            min: 0,
                        }}
                    />
                </>}

            <TextField
                name="MaxAllowedUsers"
                value={values.MaxAllowedUsers}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!(errors.MaxAllowedUsers && touched.MaxAllowedUsers)}
                placeholder={translations["max_allowed_users"] || 'Max allowed users'}
                label={translations["max_allowed_users"] || 'Max allowed users'}
                margin={'dense'}
                fullWidth={true}
                type="number"
                inputProps={{
                    min: 0,
                }}
            />
            <TextField
                name="MaxRemoteDiskNumber"
                value={values.MaxRemoteDiskNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                inputProps={{
                    min: 0,
                }}
                error={!!(errors.MaxRemoteDiskNumber && touched.MaxRemoteDiskNumber)}
                placeholder={translations["max_remote_disk_number"] || 'Max remote disks'}
                label={translations["max_remote_disk_number"] || 'Max remote disks'}
                margin={'dense'}
                fullWidth={true}
                type="number"
            />
            <TextField
                name="ErasureRedemptionPeriod"
                value={values.ErasureRedemptionPeriod || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!(errors.ErasureRedemptionPeriod && touched.ErasureRedemptionPeriod)}
                placeholder={translations["erasure_redemption_period"] || 'Erasure Redemption Period'}
                label={translations["erasure_redemption_period"] || 'Erasure Redemption Period'}
                margin={'dense'}
                fullWidth={true}
                type="number"
                inputProps={{
                    min: 0,
                }}
            />
            <TextField
                name="DiagnoseRedemptionPeriod"
                value={values.DiagnoseRedemptionPeriod || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!(errors.DiagnoseRedemptionPeriod && touched.DiagnoseRedemptionPeriod)}
                placeholder={translations["diagnose_redemption_period"] || 'Diagnose Redemption Period'}
                label={translations["diagnose_redemption_period"] || 'Diagnose Redemption Period'}
                margin={'dense'}
                fullWidth={true}
                type="number"
                inputProps={{
                    min: 0,
                }}
            />
            <TextField
                name="VerificationRedemptionPeriod"
                value={values.VerificationRedemptionPeriod || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!(errors.VerificationRedemptionPeriod && touched.VerificationRedemptionPeriod)}
                placeholder={translations["verification_redemption_period"] || 'Verification redemption Period'}
                label={translations["verification_redemption_period"] || 'Verification redemption Period'}
                margin={'dense'}
                fullWidth={true}
                type="number"
                inputProps={{
                    min: 0,
                }}
            />
            <TextField
                name="CheckRedemptionPeriod"
                value={values.CheckRedemptionPeriod || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!(errors.CheckRedemptionPeriod && touched.CheckRedemptionPeriod)}
                placeholder={translations["asset_check_redemption_period"] || 'Asset check redemption period'}
                label={translations["asset_check_redemption_period"] || 'Asset check redemption period'}
                margin={'dense'}
                fullWidth={true}
                type="number"
                inputProps={{
                    min: 0,
                }}
            />
            <TextField
                name="AppleFullCheckPrice"
                value={values.AppleFullCheckPrice}
                onChange={handleChange}
                onBlur={handleBlur}
                inputProps={{
                    min: 0,
                }}
                error={!!(errors.AppleFullCheckPrice && touched.AppleFullCheckPrice)}
                placeholder={translations["checkesn_full_check_price"] || 'Apple Full Check Price'}
                label={translations["checkesn_full_check_price"] || 'Apple Full Check Price'}
                margin={'dense'}
                fullWidth={true}
                type="float"
            />
            <TextField
                name="AppleSimlockCheckPrice"
                value={values.AppleSimlockCheckPrice}
                onChange={handleChange}
                onBlur={handleBlur}
                inputProps={{
                    min: 0,
                }}
                error={!!(errors.AppleSimlockCheckPrice && touched.AppleSimlockCheckPrice)}
                placeholder={translations["checkesn_apple_simlock_price"] || 'Apple SIM Lock Check Price'}
                label={translations["checkesn_apple_simlock_price"] || 'Apple SIM Lock Check Price'}
                margin={'dense'}
                fullWidth={true}
                type="float"
            />
            <TextField
                name="GsmaCheckPrice"
                value={values.GsmaCheckPrice}
                onChange={handleChange}
                onBlur={handleBlur}
                inputProps={{
                    min: 0,
                }}
                error={!!(errors.GsmaCheckPrice && touched.GsmaCheckPrice)}
                placeholder={translations["checkesn_gsma_check_price"] || 'GSMA Blacklist Check Price'}
                label={translations["checkesn_gsma_check_price"] || 'GSMA Blacklist Check Price'}
                margin={'dense'}
                fullWidth={true}
                type="float"
            />
            <TextField
                name="SamsungWorldwideCheckPrice"
                value={values.SamsungWorldwideCheckPrice}
                onChange={handleChange}
                onBlur={handleBlur}
                inputProps={{
                    min: 0,
                }}
                error={!!(errors.SamsungWorldwideCheckPrice && touched.SamsungWorldwideCheckPrice)}
                placeholder={translations["checkesn_samsung_worldwide_check_price"] || 'Samsung Worldwide Check Price'}
                label={translations["checkesn_samsung_worldwide_check_price"] || 'Samsung Worldwide Check Price'}
                margin={'dense'}
                fullWidth={true}
                type="float"
            />
            <TextField
                name="MdmWorkCheckPrice"
                value={values.MdmWorkCheckPrice}
                onChange={handleChange}
                onBlur={handleBlur}
                inputProps={{
                    min: 0,
                }}
                error={!!(errors.MdmWorkCheckPrice && touched.MdmWorkCheckPrice)}
                placeholder={translations["checkesn_apple_mac_mdm_check_price"] || 'Apple Mac MDM Check Price'}
                label={translations["checkesn_apple_mac_mdm_check_price"] || 'Apple Mac MDM Check Price'}
                margin={'dense'}
                fullWidth={true}
                type="float"
            />
            <TextField
                name="AppleICloudLockCheckPrice"
                value={values.AppleICloudLockCheckPrice}
                onChange={handleChange}
                onBlur={handleBlur}
                inputProps={{
                    min: 0,
                }}
                error={!!(errors.AppleICloudLockCheckPrice && touched.AppleICloudLockCheckPrice)}
                placeholder={translations["checkesn_apple_icloud_lock_check_price"] || 'Apple iCloud Lock Check Price'}
                label={translations["checkesn_apple_icloud_lock_check_price"] || 'Apple iCloud Lock Check Price'}
                margin={'dense'}
                fullWidth={true}
                type="float"
            />
            <TextField
                name="AutopilotCheckPrice"
                value={values.AutopilotCheckPrice}
                onChange={handleChange}
                onBlur={handleBlur}
                inputProps={{
                    min: 0,
                }}
                error={!!(errors.AutopilotCheckPrice && touched.AutopilotCheckPrice)}
                placeholder={translations["windows_autopilot_check_price"] || 'Windows Autopilot Check Price'}
                label={translations["windows_autopilot_check_price"] || 'Windows Autopilot Check Price'}
                margin={'dense'}
                fullWidth={true}
                type="float"
            />
        </>
    )
}

export default withStyles(styles, { withTheme: true })(PlanFormConfiguration);